// Desk build only: tells Route Desk that an order was placed through its
// panel, so it can count them exactly (Odoo cannot tell a panel order from a
// phone order: both are created by "Mobile App Uganda").
//
// Message (plan 2026-10-12 "Orders placed through the panel"), posted to the
// embedding Route Desk page through the same allowlist and targeting as
// login-ready and cart-status:
//   { type: "he-desk:order-placed", orderingFor: <CHE odoo id or null>,
//     orderId: <Odoo sale.order id>, method: "cash" | "mobile_money" }
// Sent once, when POST /orders/ answers with the new order (the cart saga's
// SEND_ORDER_SUCCESS), for both payment methods. No amount, no product lines:
// Route Desk reads the amount from Odoo once the order is confirmed.

import { postToRouteDesk } from "./deskLoginPhone";

export const ORDER_PLACED_TYPE = "he-desk:order-placed";

// The order's payment_method (the backend's CreateOrderSerializer choices) ->
// the method Route Desk records. "test" and anything unknown -> null, and
// then nothing is sent.
const METHODS = {
  cash: "cash",
  momo: "mobile_money",
  airtel: "mobile_money",
  mpesa: "mobile_money",
  ihela: "mobile_money",
};

const positiveInt = (value) => {
  if (typeof value === "string" && !/^\d+$/.test(value)) return null;
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : null;
};

// Builds the message from the order reply (response.data.data) and the
// cart's ordering_for CHE. Returns null when there is nothing to count.
export const orderPlacedMessage = (responseData, orderingFor) => {
  if (!responseData || typeof responseData !== "object") return null;
  const orderId = positiveInt(responseData.id);
  // Own keys only: "constructor" and the like must not count as a method.
  const method = Object.prototype.hasOwnProperty.call(METHODS, responseData.payment_method)
    ? METHODS[responseData.payment_method] : null;
  if (!orderId || !method) return null;
  return {
    type: ORDER_PLACED_TYPE,
    orderingFor: positiveInt(orderingFor?.odoo_id),
    orderId,
    method,
  };
};

export const postOrderPlaced = (message, win = window) => postToRouteDesk(message, win);
